import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';

interface SectionCardProps {
  icon: LucideIcon;
  title: string;
  children: React.ReactNode;
}

/**
 * The two admin sections share one shape: icon, title, rule, body. `h2` rather
 * than the `h6` MUI's `variant="h6"` produced — the level now follows the page's
 * `h1`, but it stays a heading so the outline is unchanged.
 */
const SectionCard: React.FC<SectionCardProps> = ({ icon: Icon, title, children }) => (
  <Card>
    {/* SettingRow's right rail is a @lg/section query — name it or rows stack. */}
    <CardContent className="@container/section p-6">
      <div className="mb-4 flex items-center gap-2">
        <Icon className="size-7 shrink-0" strokeWidth={1.6} aria-hidden="true" />
        <h2 className="revy-cjk text-base font-semibold leading-[1.5] tracking-tight">{title}</h2>
      </div>

      <Separator className="mb-4" />

      {children}
    </CardContent>
  </Card>
);

export default SectionCard;
